import { forwardRef, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DatePicker as Component, type DatePickerProps, type DatePickerTranslations } from '@/js/libs/ui/src/V2';

export const DatePicker = memo(
  forwardRef<HTMLInputElement, DatePickerProps>(function DatePicker({ translations, ...props }, ref) {
    const [t] = useTranslation(['common']);

    const mergedTranslations = useMemo<DatePickerTranslations>(
      () => ({
        time: t('common:TIME'),
        ...translations,
      }),
      [t, translations],
    );

    return <Component translations={mergedTranslations} ref={ref} {...props} />;
  }),
);
